export default __webpack_public_path__ + "static/media/RT_slipper_clutch.2dfaed7f.png";